import { Component, HostBinding, Input } from '@angular/core';
import { ProgressFormEnum } from '../progress/progress.component';
@Component({
  standalone: false,
  selector: 'campus-task-progress-bar',
  templateUrl: './task-progress-bar.component.html',
  styleUrls: ['./task-progress-bar.component.scss'],
})
export class TaskProgressBarComponent {
  public forms: typeof ProgressFormEnum = ProgressFormEnum;

  @Input() total? = 100;
  @Input() amount?: number;
  @Input() text?: string;
  @HostBinding('class.ui-task-progress-bar--urgent')
  @Input()
  isUrgent: boolean;

  @HostBinding('class.ui-task-progress-bar--completed')
  public get isCompleted(): boolean {
    return this.amount === this.total;
  }

  @HostBinding('class.ui-task-progress-bar')
  public uiProgressClass = true;

  constructor() {}
}
